import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Evaluation/EvaluationModels/Domain/commands-core';
import { Component } from 'vue-facing-decorator';

@Component
export default class EvalModelsCommands extends VueCqrs {

	invokeDeleteEvalModelCommandV1(workspaceId: number, evalModelId: number)
	{
		const cmd = new c.DeleteEvalModelCommandV1(workspaceId, evalModelId);
		this.$command(cmd, evalModelId.toString());
	}

	invokeRenameGoalCommandV1(workspaceId: number, evalModelId: number, name: string)
	{
		const cmd = new c.RenameGoalCommandV1(workspaceId, evalModelId, name);
		this.$command(cmd, evalModelId.toString());
	}

	invokeCreateEvalModelCommandV1(workspaceId: number, projectId: number, goalName: string, chName: string)
	{
		const cmd = new c.CreateEvalModelCommandV1(workspaceId, projectId, goalName, chName);
		this.$command(cmd, chName);
	}

	invokeCloneEvalModelCommandV1(workspaceId: number, evalModelId: number, cloneGoalName: string, cloneChName: string)
	{
		const cmd = new c.CloneEvalModelCommandV1(workspaceId, evalModelId, cloneGoalName, cloneChName);
		this.$command(cmd, cloneChName);
	}

	invokeGenerateVotesCommandV1(accessUrl: string, generateVotesForAllRespondents: boolean)
	{
		const cmd = new c.GenerateVotesCommandV1(accessUrl, generateVotesForAllRespondents);
		this.$command(cmd);
	}
}
